import { Label, _decorator } from 'cc';
import BaseMachineRecord from './BaseMachineRecord';
import NumberFormatter from '../../../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import TimeLabel from '../../../../../../common/scripts/Toolkit/Components/Misc/TimeLabel';
import IHistoryData from '../../../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryData';

const { ccclass, property } = _decorator;

@ccclass('JackpotMachineRecord')
export default class JackpotMachineRecord extends BaseMachineRecord {
    @property(NumberFormatter)
    private readonly profitOrLossNumber: NumberFormatter = null;

    @property(Label)
    private readonly jackpotCount: Label = null;

    @property(NumberFormatter)
    private readonly jackpotWin: NumberFormatter = null;

    @property(TimeLabel)
    private readonly timeLabel: TimeLabel = null;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected updateContent(data: IHistoryData) {
        // protected updateContent(data: JackpotReportData) {
        // this.profitOrLossNumber.value = data.totalWin;
        // this.jackpotCount.string = data.count.toString();
        // this.jackpotWin.value = data.totalWin;
        // this.timeLabel.time = data.lastWinAt;
    }
}
